module.exports = __webpack_public_path__ + "static/media/POLITICA PTEE-LA_FT_FPADM.6ee45123.pdf";